import { createStore } from "vuex";

import auth from "./modules/auth";
import users from "./modules/users";
import settings from "./modules/settings";
import customers from "./modules/customers";
import meters from "./modules/meters";
import groups from "./modules/groups";
import readings from "./modules/readings";
import stats from "./modules/stats";
import actions from "./modules/actions";
import messages from "./modules/messages";
import transactions from "./modules/transactions";
import test_status from "./modules/test_status";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    users,
    settings,
    customers,
    meters,
    groups,
    readings,
    stats,
    actions,
    messages,
    transactions,
    test_status,
  },
});
